import { widgetApi } from "../services/api";

export interface IResolveLimitsRequest {
  corridorCode: string;
  originCountryCode?: string;
  destinationCountryCode?: string;
  payoutMethod?: string;
  payerCode?: string;
  fundingMethod?: string;
  sendCurrency?: string;
}

export interface IAmountBound {
  minSend: number | null;
  maxSend: number | null;
  currency: string | null;
  bounded: boolean;
}

interface ResolveLimitsResponse {
  success: boolean;
  data: { amount: IAmountBound };
}

/**
 * Resolve min/max send amount for a SKU + funding method.
 * POST /widget/limits/resolve
 */
export const resolveAmountLimits = async (
  input: IResolveLimitsRequest
): Promise<IAmountBound> => {
  const { data } = await widgetApi.post<ResolveLimitsResponse>(
    `/widget/limits/resolve`,
    input
  );
  return data.data.amount;
};
